<script setup>

import OrganisationLayout from "@/layouts/OrganisationLayout.vue";
import {computed, onMounted, ref} from "vue";
import {DeleteOrganisation, GetOrganisation} from "@/services/organisationService.js";
import {useRoute, useRouter} from "vue-router";
import {Skeleton} from "@/components/ui/skeleton/index.js";
import {Plus, DeleteIcon, Loader} from "lucide-vue-next";
import {Button} from "@/components/ui/button/index.js";
import {Card, CardContent, CardDescription, CardHeader, CardTitle} from "@/components/ui/card/index.js";
import {getContext} from "@/services/context.js";

const route = useRoute(); // Access the current route
const router = useRouter();

let organisationModel = ref(null);

let isLoading = ref(true);

onMounted(async () => {
  organisationModel.value = await GetOrganisation(getContext(route));

  isLoading.value = false;
});

async function deleteItem() {
  if (confirm("Are you sure you want to delete this company?")) {
    isLoading.value = true;
    
    await DeleteOrganisation(getContext(route));

    router.push({path: `/`});
  }
}
</script>

<template>
  <OrganisationLayout :organisation="organisationModel">
    <div class="flex-1 space-y-4">
      <div class="flex items-center justify-between space-y-2">
        <div class="flex items-center space-x-2">
          <Button @click="deleteItem" :disabled="isLoading">
            <Loader v-if="isLoading" class="mr-2 h-4 w-4 animate-spin"/>
            <DeleteIcon v-if="!isLoading"/>
            Delete
          </Button>
        </div>
      </div>
    </div>
  </OrganisationLayout>
</template>

<style scoped>

</style>